import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import './style.css'

// Create router
const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (browser back/forward), use it
    if (savedPosition) {
      return savedPosition
    }
    // If navigating to a hash (anchor), scroll to it
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    // Default: scroll to top when navigating to a new route
    return { top: 0, behavior: 'smooth' }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./views/HomePage.vue'),
    },
    {
      path: '/how-it-works',
      name: 'HowItWorks',
      component: () => import('./views/HowItWorksPage.vue'),
      meta: {
        title: 'How It Works - RecruiterDash',
        description: 'Learn how RecruiterDash uses AI-powered CV matching to streamline your hiring process'
      }
    },
  ],
})

// Create head manager for SEO
const head = createHead()

const app = createApp(App)

app.use(router)
app.use(head)

app.mount('#app')